<template>
    <div class="Assistir">
        <div class="container-fluid">
            <div class="row navegacao bg-blue-1 py-3 align-items-center">
                <div class="col-2 col-sm-3 px-0 pl-5">
                    <div class="p-left">
                        <span class="txt-h-5 txt-w-7 txt-size-20 txt-white c-pointer" @click="voltar">
                            <i class="fas fa-arrow-left"></i>
                            Voltar
                        </span>
                    </div>
                </div>
                <div class="col-8 col-sm-9 e text-center px-5">
                    <router-link class="txt-h-5 txt-w-7 txt-size-20 txt-white" :to="{name:'Curso', params:{id:id}}">
                        {{treinamento.nmTreinamento}}
                    </router-link>

                    
                </div>
                <div class="col-2 d-flex d-sm-none  align-items-center position-relative">
                    <span class="btn-menu txt-white txt-size-30 c-pointer" @click="showMenu = !showMenu"><i class="fas fa-bars " aria-hidden="true"></i></span>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row conteudo position-relative">
                <div :class="'col-6 col-sm-3 px-0 d-sm-flex flex-column nav-video bg-blue-2 '+(showMenu?'d-flex':'d-none')">
                    <div class="bg-blue-2 p-left py-3 pe-1">
                        <div class="input-group">
                            <input type="text" class="form-control bg-blue-2" placeholder="Pesquisar nas aulas" aria-label="pesquisaAula" aria-describedby="basic-addon2" v-model="termoFiltroAula">
                            <span class="input-group-text bg-blue-2 c-pointer">
                                <i class="fas fa-search"></i>
                            </span>
                        </div>
                    </div>

                    <div class="w-100 bg-blue-1 py-3 ">
                        <span class="p-left txt-h-5 txt-w-7 txt-size-18 txt-white">
                            Aulas
                        </span>
                    </div>
                    <template v-if="filtroAula().length > 0">
                        <div class="w-100 lst-aulas bg-blue-2 pb-5">
                            <div :class="'item-lst-aulas w-100  c-pointer '+(aula && item.idAula == aula.idAula?'active':'')" v-for="(item,index) in filtroAula()" :key="item.idAula" @click="selecionaAula(index)">
                                <div class="p-left py-4 position-relative">

                                    <span :class="'me-2 '+(item.flConcluido?'':'d-none')">
                                        <i class="icone-concluido fas fa-check-circle"></i>
                                    </span>
                                    <span :class="'me-2 '+(item.flConcluido?'d-none':'')">
                                        <i class="icone-aula fas fa-circle"></i>
                                    </span>

                                    <span class="txt-h-5 txt-size-16 txt-w-5 txt-white">
                                        {{index+1}}. {{item.nmAula}}
                                    </span>
                                </div>

                                <div class="percentual w-100">
                                    <ProgressAula :percentual="(item.percentual == null ? 0 : item.percentual)"></ProgressAula>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="item-lst-aulas w-100  c-pointer ">
                            <div class="p-left py-4 position-relative">
                                <span class="txt-h-5 txt-size-16 txt-w-5 txt-white">
                                    Nenhuma aula encontrada
                                </span>
                            </div>
                        </div>
                    </template>

                    <template v-if="lstMateriais.length > 0">
                        <div class="w-100 bg-blue-1 py-3 ">
                            <span class="p-left txt-h-5 txt-w-7 txt-size-20 txt-white">
                                Materiais
                            </span>
                        </div>

                        <div class="w-100 bg-blue-2 lst-materiais">
                            <div class="item-lst-materiais w-100 c-pointer" v-for="(item,index) in lstMateriais" :key="index" @click="abreMaterial(item)">
                                <div class="p-left py-4 position-relative">

                                    <a :href="item.urlMaterial" class="txt-h-5 txt-size-18 txt-w-5 txt-white" target="_blank">
                                        {{item.nmMaterial}}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </template>

                </div>
                <div class="col-12 col-sm-9 bg-white">
                    <div :class="'video-widget d-sm-flex flex-column '+(showMenu?'d-flex':'d-none')" v-if="usuarioTreinamentoAula">
                        <ul >
                            <li data-toggle="tooltip" data-placement="left" title="Marcar como concluído">
                                <img src="../assets/img/videoaula/marcarcompleto.png" @click="marcaCompleto" v-if="!usuarioTreinamentoAula.flConcluido" />
                                <img src="../assets/img/videoaula/marcarCompletoMarcado.svg" @click="marcaCompleto" v-else />
                            </li>
                            <li data-toggle="tooltip" data-placement="left" title="Favorito">
                                <img src="../assets/img/videoaula/favoritar.png" @click="favoritar" v-if="!usuarioTreinamentoAula.flFavorito" />
                                <img src="../assets/img/videoaula/favoritarMarcado.svg" @click="favoritar" v-else />
                            </li>
                            <li data-toggle="tooltip" data-placement="left" title="Gostei">
                                <img src="../assets/img/videoaula/like.png" @click="like" v-if="!usuarioTreinamentoAula.flGostei" />
                                <img src="../assets/img/videoaula/likeMarcado.svg" @click="like" v-else />
                            </li>
                            <li data-toggle="tooltip" data-placement="left" title="Anotações" >
                                <img class="c-pointer" src="../assets/img/videoaula/anotacoes.png" @click="modalAnotacoes = !modalAnotacoes" v-if="!flAnotacoes" />
                                <img class="c-pointer" src="../assets/img/videoaula/anotacoesMarcado.svg" @click="modalAnotacoes = !modalAnotacoes" v-else />
                            </li>
                        </ul>
                    </div>

                    <div class="container" v-if="aula">
                        <div class="video py-2 px-5">
                            <VideoPlayer :options="getUrlVideo()" :atualizarTempo="atualizarTempo" :avisoFimVideo="avisoFimVideo" :currentTime="getTempoAula()"></VideoPlayer>
                        </div>

                        <div class="row mt-4">
                            <div class="col-sm-12">
                                <div class="video-descricao">
                                    <p class="txt-h-6 txt-size-20 txt-w-7 txt-grey-3 mb-2">
                                        {{aula.nmAula}}
                                    </p>
                                    <p class="txt-h-6 txt-size-16 txt-w-5 txt-grey-3">
                                        {{aula.dsAula}}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-6">
                                <button class="btn btn-navegacao-aula bg-white txt-blue-3 txt-size-16" @click="prev" v-if="indexAula > 0">
                                    <i class="fas fa-arrow-left"></i> Aula anterior
                                </button>
                            </div>
                            <div class="col-6 d-flex justify-content-end">
                                <button class="btn btn-navegacao-aula bg-white txt-blue-3 txt-size-16" @click="next" v-if="indexAula < (lstAulas.length -1)">
                                    Próxima aula <i class="fas fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-12">
                                <div class=" text-center">
                                    <p class="d-block txt-h-6 txt-size-20 txt-w-7 txt-grey-3 mb-2">Avalie essa aula</p>
                                    <Avaliacao :nrEstrelas="5" :nrAvaliacao="usuarioTreinamentoAula.nrNotaAvaliacao" :click="avaliaAula" />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12" v-if="aula && usuarioTreinamentoAula">
                                <div class="comentarios" v-if="aula.idAula && usuarioTreinamentoAula.idUsuarioTreinamentoAula">
                                    <Comentarios :idAula="aula.idAula" :idUsuarioTreinamentoAula="usuarioTreinamentoAula.idUsuarioTreinamentoAula" />
                                    <Anotacoes :showModal="modalAnotacoes" :hideModal="modalAnotacoes" :idUsuarioTreinamentoAula="usuarioTreinamentoAula.idUsuarioTreinamentoAula" @temAnotacao="temAnotacao"></Anotacoes>
                                </div>
                            </div>
                        </div>

                    </div>
                    
                    

                </div>
            </div>
        </div>
        
        
    </div>
</template>

<script>
    import ProgressAula from '../components/ProgressAula'
    import VideoPlayer from '../components/VideoPlayer'
    import Avaliacao from '../components/Avaliacao'
    import Comentarios from '../components/Comentarios'
    import Anotacoes from '../components/Anotacoes'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import Swal from 'sweetalert2'

    export default {
        name: 'Assistir',
        components: { ProgressAula, VideoPlayer, Avaliacao, Comentarios, Anotacoes },
        props: ['id'],
        data: function () {
            return {
                indexAula: 0,
                treinamento: {},
                usuarioTreinamento: {},
                usuarioTreinamentoAula: {},
                aula: null,

                lstAulas: [],
                lstMateriais: [],
                usuarioTreinamentoAulas: [],
                lstComentarios: [],

                showMenu: false,
                flgAtualizaTempo: true,
                termoFiltroAula: "",
                flAnotacoes: false,
                modalAnotacoes: false,
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },

            
        },
        
        methods: {
            temAnotacao(param) {
                this.flAnotacoes = param;
            },

            filtroAula() {
                let $this = this;
                if ($this.termoFiltroAula != "") {
                    return $this.lstAulas.filter(function (item) {
                        return item.nmAula.toLowerCase().indexOf($this.termoFiltroAula.toLowerCase()) != -1;
                    });
                } else {
                    return $this.lstAulas;
                }
            },

            voltar() {
                this.$router.go(-1)
            },

            load() {
                this.getAulas();
                this.getMateriais();
                                
            },

            abreMaterial(material) {
                console.log(material);
            },
            marcaCompleto() {
                let $this = this;
                axios.post(`${urlApi}/UsuarioTreinamentoAula/MarcarConcluido`, $this.usuarioTreinamentoAula, {showLoading: false})
                    .then(res => {
                        if (res.data.success) {
                            $this.atualizaUsuarioTreinamentoAula(res.data.data);
                        } else {
                            avisoErro("Não foi possível marcar como completo");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível marcar como completo");
                    });
            },

            favoritar() {
                let $this = this;
                axios.post(`${urlApi}/UsuarioTreinamentoAula/Favoritar`, $this.usuarioTreinamentoAula, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            $this.atualizaUsuarioTreinamentoAula(res.data.data);
                        } else {
                            avisoErro("Não foi possível favoritar");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível favoritar");
                    });
            },
            avaliaAula(nota) {
                let $this = this;
                $this.usuarioTreinamentoAula.nrNotaAvaliacao = nota;
                axios.post(`${urlApi}/UsuarioTreinamentoAula/Avaliar`, $this.usuarioTreinamentoAula)
                    .then(res => {
                        if (res.data.success) {
                            $this.atualizaUsuarioTreinamentoAula(res.data.data);
                        } else {
                            avisoErro("Não foi possível avaliar a aula");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível avaliar a aula");
                    });
            },

            like() {
                let $this = this;
                axios.post(`${urlApi}/UsuarioTreinamentoAula/Curtir`, $this.usuarioTreinamentoAula, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            $this.atualizaUsuarioTreinamentoAula(res.data.data);
                        } else {
                            avisoErro("Não foi possível gravar o curtir");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível gravar o curtir");
                    });
            },

            anotacoes() {

            },

            getUrlVideo() {
                var options = null;
                if (this.aula.urlVideoGravado != '' && this.aula.urlVideoGravado != null) {
                    options = {
                        tpExibicao: 'Local',
                        autoplay: false,
                        controls: true,
                        aspectRatio: "16:9",
                        sources: [
                            {
                                src: this.aula.urlVideoGravado,
                                type: "video/mp4",
                            },
                        ],
                        playbackRates: [0.5, 1, 1.5, 2]
                    };
                    return options;
                } else {
                    var url = '';
                    var src = '';
                    var video = this.aula.urlEmbedVideo;
                    if (video.includes('vimeo.com')) {
                        src = video.replace("https://vimeo.com/", "");
                        url = 'https://player.vimeo.com/video/' + src
                    } else if (video.includes('youtube')) {
                        src = video.replace("https://www.youtube.com/watch?v=", "");
                        if (src.indexOf("&") > 0) {
                            src = src.substring(0, src.indexOf("&"));
                        }
                        url = 'https://www.youtube.com/embed/' + src
                    } else if (video.includes('youtu.be')) {
                        src = video.replace("https://youtu.be/", "");
                        if (src.indexOf("?") > 0) {
                            src = src.substring(0, src.indexOf("?"));
                        }
                        url = 'https://www.youtube.com/embed/' + src
                    } else {
                        url = video;
                    }

                    options = {
                        tpExibicao: 'Embed',
                        autoplay: false,
                        controls: true,
                        sources: [
                            {
                                src: url,
                            }
                        ]
                    };
                    return options;
                }
            },

            getTempoAula() {
                var $this = this;
                if ($this.usuarioTreinamentoAula) {
                    if ($this.usuarioTreinamentoAula.nrTempoAssistido) {

                        var tempo = moment.duration($this.usuarioTreinamentoAula.nrTempoAssistido).asSeconds()
                        var duracao = moment.duration($this.aula.nrTempoAula).asSeconds();

                        if (tempo < duracao - 10) {
                            return tempo;
                        } else {
                            return 0;
                        }
                        
                    }
                }
                return 0;
            },

            getAulas() {
                let $this = this;
                axios.get(`${urlApi}/UsuarioTreinamento/AssistirTreinamento`, { params: { idTreinamento: $this.id } })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.usuarioTreinamentoAulas = [];
                                $this.lstAulas = [];

                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    var value = res.data.data.rows[i];

                                    $this.treinamento.idTreinamento = value.idTreinamento;
                                    $this.treinamento.nmTreinamento = value.nmTreinamento;
                                    $this.treinamento.dsTreinamento = value.dsTreinamento;
                                    $this.treinamento.urlImagemCapa = value.urlImagemCapa;
                                    $this.treinamento.flGratis = value.flGratis;
                                    $this.treinamento.percentual = value.percentualAssistidoTreinamento;

                                    $this.usuarioTreinamento.idUsuarioTreinamento = value.idUsuarioTreinamento;
                                    $this.usuarioTreinamento.dsLogin = value.dsLogin;
                                    $this.usuarioTreinamento.vlPago = value.vlPago;
                                    $this.usuarioTreinamento.nrTransacao = value.nrTransacao;
                                    $this.usuarioTreinamento.codTransacao = value.codTransacao;

                                    let usuarioAula = {
                                        idUsuarioTreinamentoAula: value.idUsuarioTreinamentoAula,
                                        flFavorito: value.flFavorito,
                                        flGostei: value.flGostei,
                                        flConcluido: value.flConcluido,
                                        nrTempoAssistido: value.nrTempoAssistido,
                                        nrNotaAvaliacao: value.nrNotaAvaliacao,
                                        idAula: value.idAula,
                                    };
                                    $this.usuarioTreinamentoAulas.push(usuarioAula);

                                    let aula = {
                                        idAula: value.idAula,
                                        nmAula: value.nmAula,
                                        dsAula: value.dsAula,
                                        nrTempoAula: value.nrTempoAula,
                                        urlVideoGravado: value.urlVideoGravado,
                                        urlEmbedVideo: value.urlEmbedVideo,
                                        CapaAula: value.CapaAula,
                                        usuarioTreinamentoAula: usuarioAula,
                                        percentual: value.percentualAssistidoAula,
                                        flConcluido: value.flConcluido,
                                    };
                                    $this.lstAulas.push(aula);
                                }

                                if ($this.lstAulas.length > 0) {
                                    $this.selecionaAula(0);
                                }
                                
                            }
                        } else {
                            avisoErro("Não foi possível carregar dados da aula");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar dados da aula");
                    });
            },

            getMateriais() {
                let $this = this;
                axios.get(`${urlApi}/TreinamentoMaterial/Get`, { params: { idTreinamento: $this.id } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstMateriais = [];
                            if (res.data.data.rows != null) {
                                $this.lstMateriais = res.data.data.rows;
                            }
                        } else {
                            avisoErro("Não foi possível carregar os materiais");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os materiais");
                    });
            },

            prev() {
                this.selecionaAula(this.indexAula - 1);
            },

            next() {
                this.selecionaAula(this.indexAula + 1);
            },

            selecionaAula(index) {
                let $this = this;
                $this.indexAula = index;
                $this.aula = $this.lstAulas[index];
                $this.carregaAula($this.aula.idAula);
                
                $this.flgAtualizaTempo = false;
                axios.get(`${urlApi}/UsuarioTreinamentoAula/Get`, { params: { idAula: $this.aula.idAula, idUsuarioTreinamento: $this.usuarioTreinamento.idUsuarioTreinamento } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;

                            $this.usuarioTreinamentoAula = result;
                            var index = $this.usuarioTreinamentoAulas.findIndex(function (elm) {
                                return elm.idAula == $this.aula.idAula;
                            });
                            $this.usuarioTreinamentoAulas[index] = result;

                            var indexAula = $this.lstAulas.findIndex(function (elm) {
                                return elm.idAula == $this.usuarioTreinamentoAula.idAula;
                            });
                            $this.lstAulas[indexAula].usuarioTreinamentoAula = result;

                            //var usuarioTreinamentoAula = $this.usuarioTreinamentoAulas.find(x => x.idAula == $this.aula.idAula);
                            //usuarioTreinamentoAula = result;
                            //var aula = $this.lstAulas.find(x => x.idAula == $this.usuarioTreinamentoAula.idAula);
                            //aula.usuarioTreinamentoAula = result;
                            $this.flgAtualizaTempo = true;
                        } else {
                            avisoErro("Não foi possível selecionar aula");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível selecionar aula");
                    });
            },

            carregaAula(idAula) {
                let $this = this;
                axios.get(`${urlApi}/TreinamentoAula/Get/${idAula}`)
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.aula.urlImagemCapa = result.urlImagemCapa;
                            $this.aula.urlVideoGravado = result.urlVideoGravado;
                        } else {
                            avisoErro("Não foi possível selecionar aula");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível selecionar aula");
                    });
            },

            atualizarTempo(timeElapsed) {
                if (timeElapsed != null && this.flgAtualizaTempo) {
                    let $this = this;
                    $this.usuarioTreinamentoAula.nrTempoAssistido = timeElapsed;
                    axios.post(`${urlApi}/UsuarioTreinamentoAula/AtualizaTempo`, $this.usuarioTreinamentoAula, { showLoading: false })
                        .then(res => {
                            if (res.data.success) {
                                var response = res.data.data;
                                $this.atualizaUsuarioTreinamentoAula(response);
                            }
                        })
                        .catch(function () {
                            console.log("Não foi possível atualizar tempo assistido");
                        });
                }
            },

            avisoFimVideo() {
                let timerInterval;
                let $this = this;
                if ($this.indexAula < ($this.lstAulas.length - 1)) {
                    Swal.fire({
                        title: 'Aguarde...',
                        html: 'Sua próxima aula começa em <b></b>.',
                        timer: 4000,
                        timerProgressBar: true,
                        didOpen: () => {
                            Swal.showLoading()
                            const b = Swal.getHtmlContainer().querySelector('b')
                            timerInterval = setInterval(() => {
                                b.textContent = Math.ceil(Swal.getTimerLeft() / 1000)
                            }, 1000)
                        },
                        willClose: () => {
                            clearInterval(timerInterval)
                        }
                    }).then((result) => {
                        /* Read more about handling dismissals below */
                        if (result.dismiss === Swal.DismissReason.timer) {
                            $this.next();
                        }
                    })
                }
            },

            atualizaUsuarioTreinamentoAula(usuarioTreinamentoAula) {
                this.usuarioTreinamentoAula = usuarioTreinamentoAula;
                var index = this.usuarioTreinamentoAulas.findIndex(function (elm) {
                    return elm.idAula == usuarioTreinamentoAula.idAula;
                });
                this.usuarioTreinamentoAulas[index] = usuarioTreinamentoAula;

                var indexAula = this.lstAulas.findIndex(function (elm) {
                    return elm.idAula == usuarioTreinamentoAula.idAula;
                });
                this.lstAulas[indexAula].usuarioTreinamentoAula = usuarioTreinamentoAula;
                this.lstAulas[indexAula].flConcluido = usuarioTreinamentoAula.flConcluido;
                this.lstAulas[indexAula].percentual = this.calculaPercentualAula(this.usuarioTreinamentoAula.nrTempoAssistido, this.lstAulas[indexAula].nrTempoAula);

                if (this.lstAulas[indexAula].percentual >= 100 && this.lstAulas[indexAula].flConcluido == false) {
                    this.marcaCompleto();
                }
            },

            calculaPercentualAula(tempoAssistido,tempoTotal) {
                var lstAssistido = tempoAssistido.split(':');
                var segundosAssistido = (parseInt(lstAssistido[0]) * 3600);
                segundosAssistido = segundosAssistido + (parseInt(lstAssistido[1]) * 60);
                segundosAssistido = segundosAssistido + (parseInt(lstAssistido[2]));

                var lstTotal = tempoTotal.split(':');
                var segundosTotal = (parseInt(lstTotal[0]) * 3600);
                segundosTotal = segundosTotal + (parseInt(lstTotal[1]) * 60);
                segundosTotal = segundosTotal + (parseInt(lstTotal[2]));

                return Math.floor((segundosAssistido * 100) / segundosTotal);

            },
                                    
        },
        created: function () {
            this.load();
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    .navegacao{
        /*height: 6vh;*/
    }

    .conteudo {
        height: 94vh;

        .input-group {
            .form-control {
                padding: 5px 0;
                border: none;
                color: #FFF;
                font-weight: 500;
            }

            .form-control:focus {
                box-shadow: none;
            }


            .form-control::placeholder {
                color: #6E93AC;
                opacity: 1; /* Firefox */
            }

            .input-group-text {
                border: none;
                color: #6E93AC;
                border-radius: initial;
            }
        }
    }

    .p-left {
        padding-left: 4vw;
    }

    .nav-video {
        .lst-aulas {
            overflow: auto;
            height: 75vh;

            .item-lst-aulas {
                position: relative;


                .icone-concluido {
                    color: #15C26B;
                }

                .icone-aula {
                    color: #6E93AC;
                }

                .percentual {
                    display: none;
                    position: absolute;
                    bottom: 0;
                }
            }

            .item-lst-aulas.active {
                background: #0D466A;

                .percentual {
                    display: block;
                }
            }
        }

        .lst-materiais {
            overflow: auto;
            height: 75vh;
        }
    }

    .video-widget {
        width: calc(7% - 50px);

        ul {
            list-style: none;
            margin: 0;
            padding: 0;
            background: #f5f5f5;
            border: 1px solid #ced7dd;
            position: fixed;
            right: 0;
            top: 25%;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
            transition: 0.5s;
            z-index: 1;
        }

        ul li {
            padding: 20px;
            cursor: pointer;
        }

        ul li:hover {
            opacity: .8;
        }
    }


    .btn-navegacao-aula {
        background: #FFFFFF;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        border: 1px solid;
    }

    @media (max-width: 575.98px) {
        .nav-video {
            position: absolute;
            z-index: 1;
        }
    }
</style>

